import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Select, Button, Tooltip } from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_space_usetype_tvbdb,
  req_downloadfile_usm_space_usetype_tvbdb,
} from "../../api";

class SpaceUseTypeTvbdbTotal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    rooms: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "UnitType",
    searchValue: "所有單位",
    filterStatus: "",

    isShowDetailsModal: false,
    isUploadModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_usetype_tvbdb(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_usetype_tvbdb(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "部門",
        dataIndex: "UnitType",
        width: 15,
        fixed: "left",
      },
      {
        title: "使用分類",
        dataIndex: "TvedbUseType",
        width: 30,
        fixed: "left",
      },
      {
        title: "數量",
        dataIndex: "TvedbUseTypeTotal",
        width: 15,
        render: (field) => {
          return <div style={{ textAlign: "right" }}>{field}間</div>;
        },
      },
      {
        title: "坪數",
        dataIndex: "TwPingSizeAll",
        width: 20,
        render: (field) => {
          return <div style={{ textAlign: "right" }}>{field}坪</div>;
        },
      },
      {
        title: "平方公尺",
        dataIndex: "SquareMeterAll",
        width: 25,
        render: (field) => {
          return (
            <div style={{ textAlign: "right" }}>
              {field}M<sup>2</sup>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "DETAILS":
        this.setState({
          isShowDetailsModal: true,
        });
        break;
      case "UPLOAD":
        this.setState({ isUploadModal: true });
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_date_change = (value, dateString) => {
    this.setState({ startdate: dateString[0], enddate: dateString[1] });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchValue } = this.state;
    const title = (
      <>
        <Select
          value={searchValue}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchValue: value })}
        >
          <Select.Option value="所有單位">全校</Select.Option>
          <Select.Option value="旅遊學院">旅遊學院</Select.Option>
          <Select.Option value="設計學院">設計學院</Select.Option>
          <Select.Option value="藝術學院">藝術學院</Select.Option>
          <Select.Option value="管理學院">管理學院</Select.Option>
          <Select.Option value="其他單位">其他單位</Select.Option>
        </Select>
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    const btn = (
      <>
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>
          匯出
        </Button>
        <p></p>
      </>
    );

    return (
      <>
        <Card>
          {title}
          {btn}
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceUseTypeTvbdbTotal);
